import { GIT_HASH } from '~/config/env'

// getBustTheCacheImageSrc is to be used to specify an image source we want
// to bust the cache for. For ex: our product maps that update periodically.
// We don't care to do this for most slow changing images like the background
// assets dispersed across www
export const getBustTheCacheImageSrc = (path: string): string => {
  const url = new URL(path, 'https://custodiabank.com')
  url.searchParams.append('version', GIT_HASH)
  return url.pathname + url.search
}
